import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private signedToken = new BehaviorSubject<string | null>(null);

  constructor(private storageManager: BrowserStorageService) {}

  token$ = this.signedToken.asObservable();

  setToken(token: string | null) {
    if (token) {
      this.signedToken.next(token);

      this.storageManager.set('signedToken', token, 'session');
    }
  }

  getToken() {
    const savedToken = this.storageManager.get('signedToken', 'session');
    return this.signedToken.value || savedToken;
  }
}
